// extracted by mini-css-extract-plugin
module.exports = {"section-headline":"AdminChannel_section-headline__3WmBa","sectionHeadline":"AdminChannel_section-headline__3WmBa"};